<template>
  <div class="contact">
    <div >
      <div class="title">你的选择与认可</div>
      <div class="title">始终是我们强大技术支撑的源源不断的动力<span style="font-size: 48px;"></span></div>
    </div>

    <div style="text-align: center;flex-shrink: 0;">
      <div>联系我们</div>
      <div class="flex">
        <div class="">
          <img class="qrcode" alt="" src="@/assets/images/qrcode/enterprise.png"/>
          <div class="code-name">
            <img class="" src="@/assets/images/qrcode/icon.png" style="height: 20px;" alt=""/>
            <span>企业微信</span>
          </div>
        </div>
        <div style="width: 40px;"></div>

        <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2">
          <img class="qrcode" alt="" src="@/assets/images/qrcode/wechat.png"/>
          <div class="code-name">
            <img class="" :src="require('../../../assets/images/mini-weixin.png')" alt=""/>
            <span>微信号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    // 去登录
    goLogin: function () {
      this.$router.push("/login");
    },
  }
}
</script>

<style scoped lang="scss">
.contact {
  display: flex;
  justify-content: space-between;
  padding: 60px 60px 0 60px;
  align-items: center;
}

.title {
  font-size: 33px;
  font-weight: 800;
  color: #1C2839;
  line-height: 44px;
}

.button {
  width: 185px;
  height: 40px;
  margin-top: 20px;
  background-image: linear-gradient(to right, #404DFF, #918BFF);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 29px;
  border-radius: 6px;
}


.qrcode {
  width: 110px;
  height: 110px;
}

.flex {
  display: flex;
}

.code-name {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  display: flex;
  justify-content: center;

  img {
    width: 20px;
    height: 18px;
    margin-right: 10px;
  }
}
</style>
